import api from "../api/axios"

export const getPackPlanPricesMatrix = async () => {
  const res = await api.get("/pack-plan-prices")
  return res.data
}

export const savePackPlanPrices = async (cells) => {
  const res = await api.put("/pack-plan-prices", { cells })
  return res.data
}
